import { Permissionable } from '../projects/projects.types';
import { ReportLayoutChart } from '../reporting/reporting.types';

export interface Dashboard extends Permissionable {
  id: number;
  name: string;
  account_id: number;
  definition: string;
  description?: string;
  rank?: number;
  dashboard_type?: DashboardType;
  user?: {
    id: number;
    name: string;
    avatarUrl: string;
  };
  charts?: Partial<ReportLayoutChart>[][];
}

export enum DashboardType {
  Legacy = 'legacy',
  Report = 'report',
}
